import { Component, OnInit, Input } from '@angular/core';
import { TodoService } from '../../todo.service';
import { LocalUserService } from 'app/main/shared/services/localUser';

@Component({
  selector: 'todo-uploader',
  templateUrl: './todo-uploader.component.html',
  styleUrls: ['./todo-uploader.component.scss']
})
export class TodoUploaderComponent implements OnInit {

  @Input() project: any;
  @Input() task: any;
  hideUploadFileButton = false;
  isFileLoading = false;

  fileLoading = true;
  files = [];
  userId: string;
  constructor(
    private todoService: TodoService,
    private localUser: LocalUserService,
  ) {
    this.userId = this.localUser.getUserId();
  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.getFiles()
  }

  getFiles() {
    this.fileLoading = true;
    this.files = [];
    this.todoService.getAttachments(this.userId, this.project.id, this.task.id)
      .subscribe(result => {
        this.files = result;
        this.fileLoading = false;
      });
  }

  uploadList(event) {
    this.isFileLoading = true;
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];

    this.todoService.addAttachments(this.userId, this.project.id, this.task.id, file.name)
      .subscribe(result => {
        this.todoService.uploadFile(result, file)
          .subscribe(resultt => {
            this.isFileLoading = false;
            this.getFiles();
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/todo-uploader/todo-uploader.component.ts